import Vue from 'vue';
import Component from 'vue-class-component';
import {InjectReactive, Prop, Watch} from 'vue-property-decorator';
import {DynamicElement, VisitorSurveyQuestion} from '../../../Models';
import VisitorSurveyElement from '../VisitorSurveyElement/VisitorSurveyElement.vue';

@Component({
  components: {
    VisitorSurveyElement,
  },
})
export default class VisitorSurveyQuestionComponent extends Vue {
  @Prop({type: VisitorSurveyQuestion, required: true}) question: VisitorSurveyQuestion | undefined;
  @Prop({required: true}) initial: any | null | undefined;
  @Prop({type: Boolean, required: false}) validateSurvey: boolean = false;
  @InjectReactive() readonly showErrors!: boolean;

  private questionData: { id: number | null, main: any, dependant: any, type: number | null } = {id: null, main: {}, dependant: {}, type: 0};
  private validation = {main: true, dependant: true};

  get hasSelectedMatchingOption() {
    return this.matchingOptionElement !== null;
  }

  get matchingOptionElement(): DynamicElement | null | undefined {
    if (this.question && this.questionData.main.answer) {
      const dependantQuestion = this.question.dependantQuestions.find(dq => dq.optionId === this.questionData.main.answer.id);
      if (dependantQuestion) {
        return dependantQuestion.element;
      }
      return null;
    }
    return null;
  }

  created() {
    if (this.initial) {
      this.questionData.id = this.initial.value.id;
      this.questionData.main = this.initial.value.main;
      this.questionData.dependant = this.initial.value.dependant;
      this.questionData.type = this.initial.value.type;
    }
    this.questionData.id = this.question ? this.question.questionId : null;
    this.questionData.type = this.question ? this.question.element.type : null;
  }

  updateQuestion(data) {
    this.questionData.main = data.value;
    this.validation.main = !!data.valid;
    const valid = this.validateMain();
    const value = {...this.questionData};
    this.$emit('update', {value, valid});
  }

  updateDependantQuestion(data) {
    this.questionData.dependant = data.value;
    this.validation.dependant = !!data.valid;
    const valid = this.validateDependantQuestion();
    const value = {...this.questionData};
    this.$emit('update', {value, valid});
  }

  @Watch('hasSelectedMatchingOption')
  onOptionChange(newVal: boolean, oldVal: boolean) {
    // if switching an option from showing a question to not showing it -> remove data related to this dependant option
    if (!newVal) {
      this.updateDependantQuestion({value: {}, valid: true});
    }
  }

  validateMain() {
    return this.validation.main;
  }

  validateDependantQuestion() {
    return this.validation.dependant || this.matchingOptionElement === undefined;
  }

  getInitialDataForMain() {
    if (this.questionData && this.questionData.main && Object.keys(this.questionData.main).length > 0) {
      return this.questionData.main;
    }
    return null;
  }

  getInitialDataForDependant() {
    if (this.questionData && this.questionData.dependant && Object.keys(this.questionData.dependant).length > 0) {
      return this.questionData.dependant;
    }
    return null;
  }
}
